import { createContext } from "react";
import { initializeI18n } from "./initializeI18n";
/**
 * Provides translator and translations for translating UI text with i18next
 * @category Translations
 */
export const AppI18nContext = createContext(initializeI18n({
    ns: [],
    defaultNS: false,
    lng: "en-US",
    resources: {},
}));
AppI18nContext.displayName = "AppI18nContext";
//# sourceMappingURL=AppI18nContext.js.map